export default __webpack_public_path__ + "media/images/images/banner/banner-28-c5c6e9c594708a9c2f29b438ba8dd4c3.jpg";